import {
  IFacilityScheduleHour,
  IFacilityScheduleRulesUnloadTypes,
  IShipmentStopTypes,
} from 'types/graphqlTypes'

export const getFacilityHoursForStopAndUnloadType = (
  hours: IFacilityScheduleHour[],
  stopType: IShipmentStopTypes,
  unloadType: IFacilityScheduleRulesUnloadTypes
): IFacilityScheduleHour[] => {
  const relevantHours =
    hours?.filter(
      hour =>
        hour.stopType.toLowerCase() === stopType.toLowerCase() &&
        hour.unloadType.toLowerCase() === unloadType.toLocaleLowerCase()
    ) ?? []

  return relevantHours
}
